import type { ReactNode } from 'react'
import styles from './Asset.module.scss'
import { CryptoIcon } from '@/components/atoms/CryptoIcon/CryptoIcon'
import { formatTokenAmount } from '@/shared/helpers/crypto'
import { formatUsdAmount } from '@/shared/helpers/currency'
import { Token } from '@/features/Wallets/wallet.types'
import classnames from 'classnames'
import { Flex } from 'antd'

type Props = {
  onClick: () => void;
  token: Token;
  selectedToken?: Token;
  extra?: ReactNode;
}

export function Asset({ onClick, token, selectedToken, extra }: Props): ReactNode {
  return (
    <div
      onClick={onClick}
      className={classnames(
        styles.listItem,
        selectedToken?.address === token.address && styles.listItemSelected,
      )}
      key={token.address}
    >
      <CryptoIcon
        width="32px"
        height="32px"
        icon={token.cryptoBalance.symbol.toLowerCase()}
      />

      <Flex vertical gap={5}>
        <span className={styles.crypto}>
          {formatTokenAmount(token.cryptoBalance)}
          <span>{token.cryptoBalance.symbol}</span>
        </span>
        <span className={styles.fiat}>
          {formatUsdAmount(token.fiatBalance.amount)}
        </span>
      </Flex>
      {extra && <div className={styles.pos}>{extra}</div>}
    </div>
  )
}
